module.exports = __webpack_public_path__ + "assets/close.6459849c.svg";